import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Emit } from 'vue-property-decorator';
import SliderText from '@/components/SliderText.vue';
import personApis from '@/apis/personal';
import apis from '@/apis/indexApi';
import PasswordReset from '@/components/PasswordReset.vue';
import LoginCongfig from '@/class/login.config';
import { MenuItem } from '@/config/dic';
var loginInstance = new LoginCongfig();

var PageContontHeader = /*#__PURE__*/function (_Vue) {
  _inherits(PageContontHeader, _Vue);

  var _super = _createSuper(PageContontHeader);

  function PageContontHeader() {
    var _this;

    _classCallCheck(this, PageContontHeader);

    _this = _super.apply(this, arguments);
    _this.MenuItem = MenuItem;
    _this.pwdDialogVisible = false;
    _this.tipDialogVisible = false; // TOD 需要分发消息

    _this.activeIndex = MenuItem.Home;
    _this.capionList = [];
    _this.userInfo = {
      userIcon: ''
    };
    return _this;
  }

  _createClass(PageContontHeader, [{
    key: "handleSelect",
    value: function handleSelect(index) {
      this.activeIndex = index;
      this.$router.push({
        name: index
      });
      this.$store.dispatch('SET_MENU', index); // console.log('路由变化', index)
      // console.log('activeIndex', this.$refs.menu)

      return this.activeIndex;
    }
  }, {
    key: "getCapionList",
    // 获取消息通知
    value: function getCapionList() {
      var _this2 = this;

      apis.capacity().then(function (res) {
        _this2.capionList = res.data || [];
      }).catch(function (_) {});
    } // 获取个人信息

  }, {
    key: "getUserInfo",
    value: function getUserInfo() {
      var _this3 = this;

      personApis.getUserInfo().then(function (res) {
        _this3.$store.dispatch('FedSetUserIcon', res.data.userIcon);

        _this3.$store.dispatch('FedSetUserReallyName', res.data.reallyName || '');
      }).catch(function (_) {});
    } // 个人中心

  }, {
    key: "toUserPage",
    value: function toUserPage() {
      this.$router.push('/index/personal/info');
      this.$store.dispatch('SET_MENU', '');
      this.activeIndex = '';
    } // 修改密码

  }, {
    key: "updatePwd",
    value: function updatePwd() {
      this.pwdDialogVisible = true;
    }
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      this.pwdDialogVisible = false;
    } // 注销账户

  }, {
    key: "cancelAccount",
    value: function cancelAccount() {
      this.tipDialogVisible = true;
    } // 退出平台

  }, {
    key: "loginOut",
    value: function loginOut() {
      var _this4 = this;

      loginInstance.LogOut().then(function (res) {
        // window.location.reload();
        _this4.$router.push('Login');
      });
    }
  }, {
    key: "setActiveIndex",
    value: function setActiveIndex(menu) {
      if (menu && this.$route.meta.hasMenu) {
        this.activeIndex = menu;
      } else {
        this.activeIndex = '';
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.setActiveIndex(sessionStorage.getItem('activeMenu') || this.$store.getters.userInfo.activeMenu || MenuItem.Home);
      this.getCapionList();
      this.getUserInfo();
      loginInstance.GetCommonInfo();
    }
  }, {
    key: "userName",
    get: function get() {
      return this.$store.getters.userInfo.reallyName || this.$store.getters.userInfo.userName || '';
    }
  }, {
    key: "title",
    get: function get() {
      return this.$store.getters.userInfo.title || '';
    }
  }, {
    key: "photo",
    get: function get() {
      return this.$store.getters.userInfo.userIcon || '';
    }
  }]);

  return PageContontHeader;
}(Vue);

__decorate([Emit('select')], PageContontHeader.prototype, "handleSelect", null);

PageContontHeader = __decorate([Component({
  components: {
    SliderText: SliderText,
    PasswordReset: PasswordReset
  }
})], PageContontHeader);
export default PageContontHeader;